module.exports = __webpack_public_path__ + "img/phone_nav_muen.a30c8d2d.svg";